export default {
	"DetailList.LongPressToIdentifyTheQRCode": "Long press to identify the QR code",
	"DetailList.enter": "enter",
	"DetailList.TheAppletViewsTheContent": "The Applet views the content",
	"DetailList.TheFollowingItemsAreIncluded": "The following items are included",
	"DetailList.Gifts": "Gifts",
	"DetailList.Real": "Real"
}